import axios from 'axios';

// Configuration de base pour axios avec l'URL directe de l'API
const axiosPeelo = axios.create({
  baseURL: 'https://api.peelo.chat',
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Intercepteur pour ajouter automatiquement le token d'authentification
axiosPeelo.interceptors.request.use(
  (config) => {
    const userData = localStorage.getItem('user');
    if (userData) {
      try {
        const userObj = JSON.parse(userData);
        const token = userObj.data?.token;
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
      } catch (error) {
        console.error('Erreur lors de la lecture du token:', error);
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Intercepteur pour gérer les réponses et les erreurs d'authentification
axiosPeelo.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      // Token expiré ou invalide - nettoyer les données et rediriger
      /** 
      localStorage.removeItem('user');
      localStorage.removeItem('token');
      
      // Rediriger vers la page de connexion
      if (typeof window !== 'undefined') {
        window.location.href = '/login';
      }*/
    }
    return Promise.reject(error);
  }
);

export { axiosPeelo }; 